module.exports = __webpack_public_path__ + "img/barugbug.4abae96f.svg";